var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-button', { attrs: { "plain": "" }, on: { "click": _vm.resetJson } }, [_vm._v("\n  重置JSON\n")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };